import React from "react";
import { Notification } from "@/types/Notification";
import NotificationView from "./Notification";

interface NotificationItemProps {
  notification: Notification;
  onRemove: (id: number) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  onRemove,
}) => {
  const [isRemoving, setIsRemoving] = React.useState(false);

  const handleClose = () => {
    setIsRemoving(true);
    setTimeout(() => {
      onRemove(notification.id);
    }, 500);
  };

  return (
    <div
      data-id={notification.id}
      className={`notification-container ${
        isRemoving ? "animate-slide-out" : "animate-slide-in"
      }`}
    >
      <NotificationView notification={notification} onClose={handleClose} />
    </div>
  );
};

export default NotificationItem;